const WHATSAPP_URL =
  'https://wa.me/905301714669?text=Merhaba%20SARA%20KUYUMCULUK%2C%20%C3%B6zel%20bir%20tasar%C4%B1m%20talep%20etmek%20istiyorum.';

export default function HeroSection() {
  const scrollToForm = () => {
    const el = document.getElementById('lead-form');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://readdy.ai/api/search-image?query=ultra%20luxury%20gold%20jewelry%20close-up%20on%20pure%20black%20background%2C%20soft%20golden%20bokeh%20light%2C%20diamond%20pendant%20necklace%20sparkling%20light%20reflections%2C%20elegant%20feminine%20accessories%2C%20high-end%20fashion%20photography%2C%20cinematic%20ultra%20sharp%20details%2C%20warm%20amber%20gold%20tones%20against%20deep%20black%20background&width=1920&height=1080&seq=1&orientation=landscape"
          alt="Sara Kuyumculuk luxury jewelry"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-luxury-black/70 via-luxury-black/50 to-luxury-black/90" />
        <div className="absolute inset-0 bg-luxury-black/30" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full text-center px-6 md:px-12 flex flex-col items-center">
        {/* Brand tag */}
        <div className="reveal mb-8">
          <span className="font-sans text-gold text-xs tracking-luxury uppercase border border-gold/40 px-5 py-2 inline-block">
            Sara Kuyumculuk
          </span>
        </div>

        {/* Main headline */}
        <h1 className="reveal reveal-delay-1 font-serif text-5xl sm:text-6xl md:text-7xl lg:text-8xl text-white font-light leading-tight max-w-5xl">
          Kendine Özel Tasarlanmış
          <br />
          <em className="text-gold-gradient not-italic">Bir Takıya Hazır Mısın?</em>
        </h1>

        {/* Sub text */}
        <p className="reveal reveal-delay-2 mt-8 font-sans text-white/60 text-sm md:text-base tracking-wide max-w-xl leading-relaxed">
          Altın ve mücevherde zarafetin son noktası.
          <br />
          <span className="text-white/80">Siz seçin, biz tasarlayalım.</span>
        </p>

        {/* Gold divider */}
        <div className="reveal reveal-delay-3 mt-10 w-24 gold-line mx-auto" />

        {/* CTA buttons */}
        <div className="reveal reveal-delay-4 mt-10 flex flex-col sm:flex-row gap-4 items-center">
          <button
            onClick={scrollToForm}
            className="btn-gold px-10 py-4 text-xs rounded-sm whitespace-nowrap"
          >
            Tasarımını Oluştur
          </button>
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="nofollow noreferrer"
            className="btn-outline-gold px-10 py-4 text-xs rounded-sm whitespace-nowrap flex items-center gap-2"
          >
            <i className="ri-whatsapp-line text-base" />
            WhatsApp&apos;tan Yaz
          </a>
        </div>

        {/* Scroll indicator */}
        <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 opacity-50">
          <span className="font-sans text-white text-xs tracking-luxury uppercase">Keşfet</span>
          <div className="w-px h-12 bg-gradient-to-b from-gold to-transparent" />
        </div>
      </div>
    </section>
  );
}
